import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "underline",
  "use": "underline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"underline\">\n<path d=\"M12,17c-1.9,0-3.6-0.7-4.9-2.1C5.7,13.6,5,11.9,5,10V3c0-0.6,0.4-1,1-1s1,0.4,1,1v7c0,1.3,0.5,2.6,1.5,3.5S10.7,15,12,15\n\tc1.3,0,2.6-0.5,3.5-1.5c0.9-0.9,1.5-2.2,1.5-3.5V3c0-0.6,0.4-1,1-1s1,0.4,1,1v7c0,1.9-0.7,3.6-2.1,4.9C15.6,16.3,13.9,17,12,17z\" />\n<path d=\"M20,22H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h16c0.6,0,1,0.4,1,1S20.6,22,20,22z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol